import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
const TONE_CLASSES = {
    green: {
        selectedBorder: "border-bliks-green-500",
        selectedBg: "bg-bliks-green-surface",
        ring: "shadow-[0_0_0_3px_var(--color-bliks-green-ring)]",
        radio: "border-bliks-green-600 bg-bliks-green-500",
        dashed: "border-bliks-green-500"
    },
    amber: {
        selectedBorder: "border-warning-solid",
        selectedBg: "bg-warning-solid/[0.06]",
        ring: "shadow-[0_0_0_3px_rgba(245,165,36,0.15)]",
        radio: "border-warning-solid bg-warning-solid",
        dashed: "border-warning-solid"
    }
};
export function ChoiceCard({ icon, title, hint, selected = false, onClick, disabled = false, tone = "green", children, className, id, role = "button" }) {
    const t = TONE_CLASSES[tone];
    const handleKeyDown = (e)=>{
        if (disabled || !onClick) return;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        id: id,
        role: role,
        "aria-pressed": role === "button" ? selected : undefined,
        "aria-checked": role !== "button" ? selected : undefined,
        "aria-disabled": disabled || undefined,
        tabIndex: disabled ? -1 : 0,
        onClick: disabled ? undefined : onClick,
        onKeyDown: handleKeyDown,
        className: cn("w-full box-border overflow-hidden rounded-xl border bg-white text-left outline-none transition-all duration-150 ease-out", selected ? `${t.selectedBorder} ${t.selectedBg} ${t.ring}` : "border-line", disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer focus-visible:ring-2 focus-visible:ring-bliks-green-500/40", className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-start gap-3 p-3.5",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        "aria-hidden": true,
                        className: cn("mt-0.5 flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full border-[1.5px]", selected ? t.radio : "border-line-strong bg-white"),
                        children: selected && /*#__PURE__*/ _jsx("span", {
                            className: "block h-1.5 w-1.5 rounded-full bg-foreground"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "min-w-0 flex-1",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-2 text-sm font-bold text-foreground",
                                children: [
                                    icon && /*#__PURE__*/ _jsx("span", {
                                        className: cn("inline-flex items-center justify-center", selected ? "text-bliks-green-700" : "text-fg-secondary"),
                                        children: icon
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "min-w-0 truncate",
                                        children: title
                                    })
                                ]
                            }),
                            hint && /*#__PURE__*/ _jsx("div", {
                                className: "mt-1 text-[12.5px] leading-[1.5] text-muted-foreground",
                                children: hint
                            })
                        ]
                    })
                ]
            }),
            selected && children && /*#__PURE__*/ _jsx("div", {
                className: cn("border-t border-dashed bg-white px-3.5 pb-3.5 pt-1 pl-11", t.dashed),
                onClick: (e)=>e.stopPropagation(),
                children: children
            })
        ]
    });
}

//# sourceMappingURL=ChoiceCard.js.map